import React from 'react';
import styled from 'styled-components';
import { Stack } from '@mui/material';
import { ReactComponent as DbtExpectationsIcon } from '../../assets/dbt-expectations-icon.svg';
import { ReactComponent as DbtIcon } from '../../assets/dbt-icon.svg';
import { ReactComponent as ElementaryIcon } from '../../assets/logo-black.svg';
import OverflowTooltip from '../OverflowTooltip';

const Wrapper = styled(Stack)`
  > svg {
    path {
      fill: ${({ theme }) => theme.palette.common.gray4};
    }
  }
`;

const DbtIconStyled = styled(DbtIcon)`
  width: 12px;
  height: 12px;
  svg {
    width: 12px;
    height: 12px;
  }
`;

const ElementaryIconStyled = styled(ElementaryIcon)`
  width: 12px;
  height: 12px;
  > rect:first-child {
    fill: ${({ theme }) => theme.palette.common.gray4};
  }
`;

const getTestIcon = (packageName: string) => {
  switch (packageName) {
    case 'elementary':
      return ElementaryIconStyled;
    case 'dbt_expectations':
      return DbtExpectationsIcon;
    default:
      return DbtIconStyled;
  }
};

const testNameByPackageRenderer = (value: any) => (
  <Wrapper
    direction="row"
    sx={{ gap: 1, alignItems: 'center', fontSize: '14px' }}
  >
    {React.createElement(getTestIcon(value.package))}
    <OverflowTooltip sx={{ flex: 1 }}>{value.name}</OverflowTooltip>
  </Wrapper>
);

export default testNameByPackageRenderer;
